
// ==================== 宽表累计值指标映射配置 ====================

import { IMetricMappingConfig } from "./types";

/**
 * 累计值指标映射配置
 * 用于宽表中按时间维度（Day/Week/Month）处理指标的累计/非累计转换
 *
 * 配置说明：
 * - baseKey: 非累计时使用的指标 key
 * - accumulatedKey: 累计时使用的指标 key
 * - cnName: [非累计中文名, 累计中文名]
 * - enName: [非累计英文名, 累计英文名]
 *
 * 扩展指南：
 * 如需新增指标类型，只需在对应时间维度下添加新的配置项即可
 */
export const ACCUMULATED_METRICS_CONFIG: IMetricMappingConfig = {
  Day: [
    // 活跃用户指标
    {
      baseKey: 'active_users',
      accumulatedKey: 'avg_dau',
      cnName: ['日活跃', '日平均活跃'],
      enName: ['DAU', 'Avg.DAU'],
    },
    // IAA 指标
    {
      baseKey: 'iaa_dau',
      accumulatedKey: 'iaa_avg_dau',
      cnName: ['日活跃', '日平均活跃'],
      enName: ['DAU', 'Avg.DAU'],
    },
  ],
  Week: [
    {
      baseKey: 'active_users',
      accumulatedKey: 'avg_wau',
      cnName: ['周活跃', '周平均活跃'],
      enName: ['WAU', 'Avg.WAU'],
    },
    {
      baseKey: 'iaa_wau',
      accumulatedKey: 'iaa_avg_wau',
      cnName: ['周活跃', '周平均活跃'],
      enName: ['WAU', 'Avg.WAU'],
    },
  ],
  Month: [
    {
      baseKey: 'active_users',
      accumulatedKey: 'avg_mau',
      cnName: ['月活跃', '月平均活跃'],
      enName: ['MAU', 'Avg.MAU'],
    },
    {
      baseKey: 'iaa_mau',
      accumulatedKey: 'iaa_avg_mau',
      cnName: ['月活跃', '月平均活跃'],
      enName: ['MAU', 'Avg.MAU'],
    },
  ],
};

/**
 * 仅按日期维度展示的指标（累计时需移除）
 */
export const METRICS_ONLY_BY_DATE: string[] = ['total_users'];